import { apiStudent } from '@/lib/api-manager'
import type { DesiredEducationFormType } from '@/schemas/education/match-courses-schema'

export const saveRequestDesiredEducation = async (
  data?: DesiredEducationFormType,
  requestId?: string
) => {
  if (data) {
    const body = {
      requestId,
      createStep: 'desired_education',
      desiredEducationStep: {
        desiredEducationId: data.desiredEducationId,
        desiredEducation: data.desiredEducationName
      }
    }
    return (await apiStudent.post('v1/requests', body)).data
  }
}
